export const USER_CONSTANTS = {
  USER_RESPONSE_NULL: 'User response data is null',
  AUTH_STORAGE_KEY: 'mln.authUser',
  // Pre-migration storage keys. Never read as state; only removed.
  LEGACY_AUTH_STORAGE_KEY: 'mlnUserData',
  LEGACY_REDIRECT_STORAGE_KEY: 'redirectUrl',
};
